(function () {
  const ALLOWED_COUNTRIES = ['US', 'AT', 'BE', 'DE', 'ES', 'FR', 'IT', 'NL', 'AD', 'MC'];
  const GEO_KEY = 'userGeolocation';
  const DEFAULT_VARIANT_ID = '48360286945517';

  if (customElements.get('return-go-widget')) return;
 
  customElements.define(
    'return-go-widget',
    class ReturnGoWidget extends HTMLElement {
      constructor() {
        super();

        this.onChangeHandler = this.onChange.bind(this);
        this.onGeoReadyHandler = this.onGeoReady.bind(this);
        this.onCartUpdatedHandler = this.onCartUpdated.bind(this);
        this.isUpdating = false;
        this.cart = null;
        this.geoRetryTimer = null;
      }

      get variantId() {
        return this.getAttribute('data-return-go-variant-id') || DEFAULT_VARIANT_ID;
      }

      get toggle() {
        return this.querySelector('[data-return-go-toggle]');
      }

      connectedCallback() {
        this.toggle?.addEventListener('change', this.onChangeHandler);
        document.addEventListener('geo:ready', this.onGeoReadyHandler);
        document.addEventListener('cart:updated', this.onCartUpdatedHandler);

        this.cartUpdateUnsubscriber = theme.pubsub?.subscribe(
          theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
          this.onCartUpdate.bind(this)
        );

        this.sync();
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('change', this.onChangeHandler);
        document.removeEventListener('geo:ready', this.onGeoReadyHandler);
        document.removeEventListener('cart:updated', this.onCartUpdatedHandler);
        this.cartUpdateUnsubscriber?.();
        clearTimeout(this.geoRetryTimer);
      }

      onGeoReady(event) {
        this.applyGeoState(event.detail?.countryCode);
      }

      onCartUpdated(event) {
        this.cart = event.detail?.cart || null;
        this.sync();
      }

      onCartUpdate(event) {
        this.cart = event?.cart || null;
        this.sync();
      }

      onChange(event) {
        if (event.target.checked) {
          this.addReturnGo();
        }
        else {
          this.removeReturnGo();
        }
      }

      async sync(attempts = 0) {
        const cart = this.cart || await this.fetchCart();
        const countryCode = this.getStoredCountryCode();

        this.applyCartState(cart);

        if (countryCode && countryCode !== 'null') {
          this.applyGeoState(countryCode);
          return;
        }

        if (attempts < 10) {
          clearTimeout(this.geoRetryTimer);
          this.geoRetryTimer = setTimeout(() => this.sync(attempts + 1), 10000);
        }
      }

      applyCartState(cart) {
        const item = this.findReturnGoItem(cart);
        const inCart = Boolean(item);

        this.style.display = inCart ? 'none' : '';
        if (this.toggle) {
          this.toggle.checked = inCart;
          this.toggle.disabled = this.isUpdating;
        }
      }

      applyGeoState(countryCode) {
        const isAllowed = ALLOWED_COUNTRIES.includes(countryCode);

        this.classList.toggle('return-widget_active', isAllowed);
        this.classList.toggle('return-widget_hide', !isAllowed);
      }

      getStoredCountryCode() {
        try {
          return localStorage.getItem(GEO_KEY);
        }
        catch (_) {
          return null;
        }
      }

      findReturnGoItem(cart) {
        if (!cart?.items) return null;
        return cart.items.find((item) => item.variant_id == this.variantId);
      }

      async fetchCart() {
        try {
          const response = await fetch(theme.routes.cart_url, theme.utils.fetchConfig('json', 'GET'));
          const cart = await response.json();
          this.cart = cart;
          return cart;
        }
        catch (error) {
          console.error('[return-widget] Cart fetch error:', error);
          return null;
        }
      }

      getBundledSections() {
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
          bubbles: true,
          detail: { sections }
        }));
        return sections;
      }

      async addReturnGo() {
        if (this.isUpdating) return;

        this.isUpdating = true;
        this.applyCartState(this.cart);

        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', 1);
        formData.append('sections', this.getBundledSections());
        formData.append('sections_url', window.location.pathname);

        const config = theme.utils.fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        try {
          const parsedState = await (await fetch(theme.routes.cart_add_url, config)).json();

          if (parsedState.status) {
            console.error('[return-widget] Add error:', parsedState.description || parsedState.errors);
            if (this.toggle) this.toggle.checked = false;
            return;
          }

          const cart = await this.fetchCart();
          if (cart) {
            cart.sections = parsedState.sections;
            this.publishCartUpdate(cart);
          }
        }
        catch (error) {
          console.error('[return-widget] Add error:', error);
          if (this.toggle) this.toggle.checked = false;
        }
        finally {
          this.isUpdating = false;
          this.applyCartState(this.cart);
        }
      }

      async removeReturnGo() {
        if (this.isUpdating) return;

        this.isUpdating = true;
        this.applyCartState(this.cart);

        try {
          const cart = this.cart || await this.fetchCart();
          const item = this.findReturnGoItem(cart);
          if (!item) return;

          const body = JSON.stringify({
            id: item.key,
            quantity: 0,
            sections: this.getBundledSections(),
            sections_url: window.location.pathname
          });

          const parsedState = await (await fetch(theme.routes.cart_change_url, { ...theme.utils.fetchConfig(), body })).json();
          this.cart = parsedState;
          this.publishCartUpdate(parsedState);
        }
        catch (error) {
          console.error('[return-widget] Remove error:', error);
        }
        finally {
          this.isUpdating = false;
          this.applyCartState(this.cart);
        }
      }

      publishCartUpdate(cart) {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: 'return-go',
          productVariantId: this.variantId,
          cart
        });
      }
    }
  );
})();
